import { Injectable } from '@angular/core';
import { ApplicationAdvisoriesListAem } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { AlertAdvisoriesExtendedFacade } from './alert-advisories-extended.facade';

@Injectable({
  providedIn: 'root'
})
export class AlertAdvisoriesExtendedHelper extends AlertAdvisoriesExtendedFacade {
  setDefaultAdvisories(): boolean {
    const advisoryCookie = this.cookieHelper.getCookieValue('ad_alert');
    if (!advisoryCookie) {
      return true;
    }

    const normalizedAdAlertCookie = this.adAlertCookie.replace(/\s/g, '');
    const cookieValueExists =
      normalizedAdAlertCookie.indexOf(advisoryCookie) !== -1;
    return !cookieValueExists;
  }

  setAdvisoryCookie(
    adAppKey: string,
    advisory: ApplicationAdvisoriesListAem,
    appKey: string,
    contextPath: string
  ): void {
    if (advisory.advisoryKey === adAppKey) {
      this.adCookieArray.push(appKey);
    } else {
      this.isADNewCookierequired = true;
      this.isAdvisoryMatch = true;
      this.selectedAdvisory = advisory;
      this.adCookieArray.push(`${contextPath}:${advisory.advisoryKey}`);
    }
  }

  checkAdvisoryCookie(
    advisoryAppCookie: string[],
    contextPath: string,
    advisory: ApplicationAdvisoriesListAem,
    appKey: string
  ): void {
    const adApp = advisoryAppCookie[0];
    const adAppKey = advisoryAppCookie[1];
    if (contextPath === adApp) {
      this.setAdvisoryCookie(adAppKey, advisory, appKey, contextPath);
    } else {
      this.adCookieArray.push(appKey);
    }
  }

  checkAdvisoryAppCookie(
    appKey: string,
    contextPath: string,
    advisory: ApplicationAdvisoriesListAem
  ): void {
    const advisoryAppCookie = appKey.split(':');
    if (advisoryAppCookie && advisoryAppCookie.length > 1) {
      this.checkAdvisoryCookie(
        advisoryAppCookie,
        contextPath,
        advisory,
        appKey
      );
    }
  }

  close() {
    this.showAlertAdvisoriesHeader.set(false);
    const currentData = this.alertAdvisoriesContent();
    const value = {
      ...currentData,
      showAlertAdvisoriesHeader: this.showAlertAdvisoriesHeader
    };
    this.alertAdvisoriesContent.set(value);
    this.cookieHelper.setCookieName('ad_alert', this.adAlertCookie, 0, true);
  }
}
